import { createRouter, createWebHistory } from 'vue-router';
import { ensureVisitJwt } from '../utils/auth';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/file', component: () => import('@/panel/File-View.vue') },
  { path: '/share', component: () => import('@/panel/Share-View.vue') },
  { path: '/login', component: () => import('@/panel/Login-View.vue') },
  { path: '/settings', component: () => import('@/panel/Setting-View.vue') },
  { path: '/download', component: () => import('@/panel/Download-View.vue') },
  { path: '/download/:shareCode', component: () => import('@/panel/Download-View.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/login' }
];

const router = createRouter({ history: createWebHistory(), routes });

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 登录页面和下载页面允许匿名访问，不需要JWT验证
  if (to.path === '/login' || to.path.startsWith('/download')) {
    next();
    return;
  }
  
  // 其他页面需要JWT验证
  const isValid = await ensureVisitJwt();
  if (isValid) {
    next();
  } else {
    next('/login');
  }
});

// 监听登录失效事件，自动跳转登录
window.addEventListener('auth:login-required', () => {
  router.replace('/login');
});

export default router;